/* =========================================================
AJAX FILTERS (SHOPIFY NATIVE - NO RELOAD)
========================================================= */
const filterForm = document.querySelector('.facets__form');
const SECTION_ID =
  document.querySelector('#facet-form')?.getAttribute('section-id') ||
  document.querySelector('[id^="shopify-section-template--"]')
    ?.id.replace('shopify-section-', '');

function getProvinceValue() {
  return localStorage.getItem("ProvinceValue");
}
const provinceValue = getProvinceValue();
const provinceTag = `province_${provinceValue.toUpperCase()}`;

/* =========================================================
   FILTER DRAWER TOGGLE — FACETS SAFE (DELEGATED)
   ========================================================= */

// document.addEventListener('click', function (e)  {
//   const button = e.target.closest('[data-toggle-filters]');
//   if (!button) return;

//   e.stopPropagation();
  
//   const targetId = button.getAttribute('aria-controls');
//   const container = document.getElementById(targetId);
//   if (!container) return;
  
//   const isOpen = container.classList.toggle('open')
//   button.setAttribute('aria-expanded', isOpen);
// });

// document.addEventListener('click', function (e) {
//   const facetLink = e.target.closest('.active-facets a');
//   if (!facetLink) return;

//   e.preventDefault();

//   applyFiltersFromURL(facetLink.href);
// });

// // Close when clicking outside
// document.addEventListener('click', (e) => {
//   document.querySelectorAll('.custom-filters-wrapper.open').forEach(container => {
//     const button = document.querySelector(
//       `[aria-controls="${container.id}"]`
//     );

//     if ( container.contains(e.target) || (button && button.contains(e.target))) {
//       return;
//     }

//     container.classList.remove('open');
//     if (button) button.setAttribute('aria-expanded', false);
//   });
// });

document.addEventListener('click', (e) => {
  const openFilters = document.querySelectorAll(
    '.custom-filters-wrapper.open'
  );

  openFilters.forEach(container => {
    const button = document.querySelector(
      `[aria-controls="${container.id}"]`
    );

    const clickedInsideFilter = e.target.closest(
      '.custom-filters-wrapper'
    );

    const clickedToggleButton =
      button && button.contains(e.target);

    if (clickedInsideFilter || clickedToggleButton) {
      return;
    }

    container.classList.remove('open');
    container.setAttribute('inert', '');

    if (button) {
      button.setAttribute('aria-expanded', 'false');
    }
  });
});

document.addEventListener('click', function (e)  {
  const button = e.target.closest('[data-toggle-filters]');
  if (!button) return;

  e.stopPropagation();

  const targetId = button.getAttribute('aria-controls');
  const container = document.getElementById(targetId);

  if (!container) return;

  const isOpen = container.classList.contains('open');

  if (isOpen) {
    container.classList.remove('open');
    container.setAttribute('inert', '');
    button.setAttribute('aria-expanded', 'false');
  } else {
    container.classList.add('open');
    container.removeAttribute('inert');
    button.setAttribute('aria-expanded', 'true');
  }
});

document.addEventListener('click', function (e) {
  const facetLink = e.target.closest('.active-facets a');
  if (!facetLink) return;

  e.preventDefault();

  applyFiltersFromURL(facetLink.href);
});

// Pagination click
document.addEventListener('click', function (e) {
  const link = e.target.closest('.collection__pagination a');
  if (!link) return;

  e.preventDefault();

  const currentUrl = new URL(window.location.href);
  const newUrl = new URL(link.href, window.location.origin);

  // Preserve ALL current params
  currentUrl.searchParams.forEach((value, key) => {
    if (!newUrl.searchParams.has(key)) {
      newUrl.searchParams.set(key, value);
    }
  });

  applyFiltersFromURL(newUrl.toString());
});

/* -----------------------------
Serialize filters
----------------------------- */
function serializeFilters(form) {
  const formData = new FormData(form);
  return new URLSearchParams(formData);
}

/* -------------------------------
  Build url to cache preload data
------------------------------- */
function buildFilterURL(form, includeSection = false) {
  const url = new URL(window.location.href);
  const formParams = serializeFilters(form);
  let isCarrierPromotion = false;
  
  // REMOVE pagination
  url.searchParams.delete('page');
  
  // remove old filters
  [...url.searchParams.keys()].forEach(key => {
    if (key.startsWith('filter.')) {
      url.searchParams.delete(key);
    }
  });

  const carriers = formParams.getAll('filter.p.m.custom.device_carrier');
  const promotion = formParams.getAll('filter.p.m.custom.device_promotion');
  const normalizedCarriers = carriers
    .map(c => c.toLowerCase().replace(' mobile', ' Mobile').trim().replace("carrier_",""))
    .filter(Boolean);
  const hasCarrier = carriers.length > 0;
  const haspromotion = promotion.length > 0;

  // add new filters
  formParams.forEach((value, key) => {
    let normalizedValue = value;
      
    // Carriers and promotion filter
    if (normalizedValue === "deals_Promotion" && hasCarrier && haspromotion) {
      normalizedCarriers.forEach(carrier => {
        const carrierFormatted =
          carrier.charAt(0).toUpperCase() + carrier.slice(1);

        let promoTag = `promotion_${carrierFormatted}_national`;

        if (carrier.toLowerCase() == 'sasktel'){
          promoTag = `promotion_${carrierFormatted}_SK`;
        }

        url.searchParams.append(key, promoTag);
        isCarrierPromotion = true;
      });
      // url.searchParams.append(key, normalizedValue);

    } else {
      url.searchParams.append(key, normalizedValue);
      if (provinceValue == 'sk'){
        url.searchParams.append(key, "promotion_Sasktel_SK");
      }
    }
    
  });

  if (provinceValue) {
    url.searchParams.set('prov', provinceValue);
    url.searchParams.set('filter.p.m.custom.device_province', provinceTag);
  }


  if (includeSection) {
    url.searchParams.set('section_id', SECTION_ID);
  } else {
    url.searchParams.delete('section_id');
  }

  return {
    finalUrl: url.toString(),
    isCarrierPromotion
  };
}

window.FILTER_PRELOAD_CACHE = {};
const FILTER_PENDING = new Set();

// Helper to clear cache and avoid memory growth
const MAX_CACHE = 10;

function setPreloadCache(url, html) {
  const keys = Object.keys(FILTER_PRELOAD_CACHE);

  if (keys.length >= MAX_CACHE) {
    delete FILTER_PRELOAD_CACHE[keys[0]];
  }

  FILTER_PRELOAD_CACHE[url] = html;
}

// End helper

async function preloadFilters(form) {
  const url = buildFilterURL(form, true).finalUrl;

  // prevent duplicate fetch
  if (FILTER_PRELOAD_CACHE[url] || FILTER_PENDING.has(url)) return;

  FILTER_PENDING.add(url);

  try {
    const res = await fetch(url, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });

    const html = await res.text();

    setPreloadCache(url, html);

  } catch (err) {
    console.error("Preload error:", err);
  } finally {
    FILTER_PENDING.delete(url);
  }
}

/* -----------------------------
Apply filters (SHOPIFY AJAX)
----------------------------- */
async function applyFiltersAJAX(form) {

  const url = new URL(window.location.href);
  const formParams = serializeFilters(form);
  const compareProducts = localStorage.getItem('comparableProducts');

   // remove old filters
  [...url.searchParams.keys()].forEach(key => {
    if (key.startsWith('filter.')) {
      url.searchParams.delete(key);
    }
  });

  // add new filters
  formParams.forEach((value, key) => {
    url.searchParams.append(key, value);
  });

  // Carriers and promotion filter
  const carriers = formParams.getAll('filter.p.m.custom.device_carrier');
  const promotion = formParams.getAll('filter.p.m.custom.device_promotion');
  const hasDealsPromotion = url.searchParams.getAll('filter.p.m.custom.device_promotion').some(v => v.toLowerCase() === 'deals_promotion');
  const normalizedCarriers = carriers
    .map(c => c.toLowerCase().replace(' mobile', '').trim().replace("carrier_",""))
    .filter(Boolean);
  const hasCarrier = carriers.length > 0;
  const haspromotion = promotion.length > 0;

  if (hasCarrier && haspromotion) {
    url.searchParams.delete('filter.p.m.custom.device_promotion');
    normalizedCarriers.forEach(carrier => {
      const carrierFormatted = carrier.charAt(0).toUpperCase() + carrier.slice(1);

      let promoTag = `promotion_${carrierFormatted}_national`;

      if (carrier.toLowerCase() == 'sasktel'){
        promoTag = `promotion_${carrierFormatted}_SK`;
      }

      // ADD promo filter (do NOT delete original)
      url.searchParams.append('filter.p.m.custom.device_promotion', promoTag);
    });
  }

  if (provinceValue) {
    url.searchParams.set('prov', provinceValue);
    url.searchParams.set('filter.p.m.custom.device_province', provinceTag);
  }

  url.searchParams.set('section_id', SECTION_ID);

  const container = document.querySelector('reveal-items');
  const emptyState = document.querySelector('.empty-state');

  if (!container) return;

  // Prevent scrolling bar appearing and resizing
  const currentHeight = container.offsetHeight;
  container.style.minHeight = currentHeight + 'px';
  container.style.overflow = 'hidden';

  container.innerHTML = getSkeletonHTML();

  try {
    const { finalUrl, isCarrierPromotion } = buildFilterURL(form, true);

    let html;

    if (FILTER_PRELOAD_CACHE[finalUrl]) {
      html = FILTER_PRELOAD_CACHE[finalUrl];
    } else {
      const res = await fetch(finalUrl, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      html = await res.text();
    }
    
    // Check latency when filtering to only delay skeleton rendering if response is too fast
    const start = performance.now();

    const doc = new DOMParser().parseFromString(html, 'text/html');

    const elapsed = performance.now() - start;

    // Delay Skeleton rendering when filtering
    if (elapsed < 150) {
      await new Promise(resolve => setTimeout(resolve, 150 - elapsed));
    }

    const newSection = doc.querySelector('reveal-items');
    const newPagination = doc.querySelector('.collection__pagination');

    //  update facets UI 
    const newFacets = doc.querySelector('.facets-summary');
    const currentFacets = document.querySelector('.facets-summary');

    if (newFacets && currentFacets) {
      currentFacets.innerHTML = newFacets.innerHTML;      
    }

    syncFacetsFromShopify(doc, isCarrierPromotion);
    
    if (newSection) {
      // update products

      // ** This part is for a better rendering when updating products from filtering **
      const oldWrapper = container.querySelector('.products-wrapper');

      const temp = document.createElement('div');
      temp.innerHTML = newSection.innerHTML;

      const newContent = temp.innerHTML;

      const newWrapper = document.createElement('div');
      newWrapper.className = 'products-wrapper is-loaded';
      newWrapper.innerHTML = newContent;

      if (oldWrapper) {
        container.replaceChild(newWrapper, oldWrapper);
      } else {
        container.appendChild(newWrapper);
      }

      requestAnimationFrame(() => {
        newWrapper.classList.add('fade-in');
      });

      // ** End filtering rendering from skeleton **

      renderDevicesLayout();
      updateCounterFromShopify(doc);

      // pagination update
      const currentPagination = document.querySelector('.collection__pagination');

      if (currentPagination) {
        if (newPagination) {
          currentPagination.innerHTML = newPagination.innerHTML;
          currentPagination.style.display = "";
        } else {
          currentPagination.innerHTML = "";
          currentPagination.style.display = "none"; //
        }
      }

      setTimeout(() => {
        container.style.minHeight = '';
        container.style.overflow = '';
      }, 250);

    } else {
      container.innerHTML = `
        <div class="empty-state">
          <div class="empty-state__icon-wrapper"><svg role="presentation" fill="none" focusable="false" stroke-width="1" width="32" height="32" class="icon icon-picto-stop" viewBox="0 0 24 24">
            <path d="M11.715 21.43c5.365 0 9.715-4.35 9.715-9.715S17.08 2 11.715 2 2 6.35 2 11.715s4.35 9.715 9.715 9.715Z" fill="currentColor" fill-opacity=".12"></path>
            <path d="M21.43 11.715c0 5.365-4.35 9.715-9.715 9.715a9.686 9.686 0 0 1-6.953-2.93A9.683 9.683 0 0 1 2 11.715C2 6.35 6.35 2 11.715 2A9.683 9.683 0 0 1 18.5 4.762a9.686 9.686 0 0 1 2.93 6.953Z" fill="currentColor" fill-opacity=".12"></path>
            <path d="M18.5 4.762A9.683 9.683 0 0 0 11.715 2C6.35 2 2 6.35 2 11.715A9.683 9.683 0 0 0 4.762 18.5M18.5 4.762a9.686 9.686 0 0 1 2.93 6.953c0 5.365-4.35 9.715-9.715 9.715a9.686 9.686 0 0 1-6.953-2.93M18.5 4.762 4.762 18.5" stroke="currentColor"></path>
          </svg><span class="count-bubble count-bubble--lg">0</span>
        </div>
        <div class="prose">
          <p class="h5">No devices match those filters.</p>
          <a class="button button--xl" href="/collections/device">Clear all</a></div>
        </div>
      `;
    }

    url.searchParams.delete('section_id');
    if (provinceValue == 'sk' && hasDealsPromotion ){
      url.searchParams.append('filter.p.m.custom.device_promotion', "promotion_Sasktel_SK");
    }

    window.history.replaceState({}, '', url.toString());

    localStorage.setItem('comparableProducts', compareProducts);
    compareItemLimit();

  } catch (err) {
    console.error('Filter AJAX error:', err);
  }
}

/* -----------------------------
Skeleton loader
----------------------------- */
function getSkeletonHTML(count = 8) {
  let skeletons = '';

  for (let i = 0; i < count; i++) {
    skeletons += `
      <div class="product-item product-card skeleton-card">
        
        <!-- IMAGE -->
        <div class="product-card__figure">
          <div class="skeleton-image"></div>
        </div>

        <!-- BODY -->
        <div class="product-card__info">

          <!-- TITLE -->
          <div class="skeleton-line skeleton-title"></div>
          <div class="skeleton-line skeleton-subtitle"></div>

          <!-- CARRIER BADGES -->
          <div class="skeleton-carriers">
            <div class="skeleton-badge"></div>
            <div class="skeleton-badge"></div>
            <div class="skeleton-badge"></div>
          </div>

          <!-- PRICE -->
          <div class="skeleton-price-block">
            <div class="skeleton-line skeleton-price"></div>
            <div class="skeleton-line skeleton-price-small"></div>
          </div>

        </div>

        <!-- COMPARE BUTTON -->
        <div class="comparable-custom-action skeleton-compare">
          <div class="skeleton-checkbox"></div>
          <div class="skeleton-line skeleton-compare-text"></div>
        </div>

      </div>
    `;
  }

  return `
    <div class="products-wrapper is-loading">
      <div class="collection-device-plp">
        <div class="collection__results">
          <div class="product-grid skeleton-grid">
            ${skeletons}
          </div>
        </div>
      </div>
    </div>
  `;
}

/* -----------------------------
Update counter from Shopify
----------------------------- */
function updateCounterFromShopify(doc) {
    const counters = document.querySelectorAll(`
    .product-count-collection p,
    .mobile-product-count-collection p
  `);

  if (!counters.length) return;

  const countEl = doc.querySelector('[data-total-count]');
  if (!countEl) return;

  const count = parseInt(countEl.textContent.trim(), 10);

  const labels = {
    en: ['Device', 'Devices'],
    fr: ['Appareil', 'Appareils']
  };

  const lang = document.documentElement.lang.startsWith('fr')
    ? 'fr'
    : 'en';

  const [singular, plural] = labels[lang];
  const label = count === 1 ? singular : plural;

  counters.forEach(el => {
    el.textContent = `${count} ${label}`;
  });

  if (window.innerWidth <= 999) {
    document
      .querySelectorAll('.mobile-product-count-collection p')
      .forEach(el => {
        el.style.display = 'block';
      });
  }    
}


async function applyFiltersFromURL(urlString) {

  const url = new URL(urlString, window.location.origin);

  if (provinceValue) {
    url.searchParams.set('prov', provinceValue);
    url.searchParams.delete('filter.p.m.custom.device_province');
    url.searchParams.set('filter.p.m.custom.device_province', provinceTag);
  }

  url.searchParams.set('section_id', SECTION_ID);

  const container = document.querySelector('reveal-items');

  if (!container){
    return;
  }

  container.innerHTML = getSkeletonHTML();

  try {
    const res = await fetch(url.toString(), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });

    // Check latency when filtering to only delay skeleton rendering if response is too fast
    const start = performance.now();

    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    
    const elapsed = performance.now() - start;

    // Delay Skeleton rendering when filtering
    if (elapsed < 200) {
      await new Promise(resolve => setTimeout(resolve, 200 - elapsed));
    }

    const newSection = doc.querySelector('reveal-items');
    if (!newSection) {
      console.error('Missing reveal-items — likely wrong section_id');
      return;
    }
    const newPagination = doc.querySelector('.collection__pagination');
    const newFacets = doc.querySelector('.facets-summary');

    // update products
    if (newSection) {
      // ** Wrapper logic for better rendering when filtering **
      const oldWrapper = container.querySelector('.products-wrapper');

      const temp = document.createElement('div');
      temp.innerHTML = newSection.innerHTML;

      const newContent = temp.innerHTML;

      const newWrapper = document.createElement('div');
      newWrapper.className = 'products-wrapper is-loaded';
      newWrapper.innerHTML = newContent;

      if (oldWrapper) {
        container.replaceChild(newWrapper, oldWrapper);
      } else {
        container.appendChild(newWrapper);
      }

      // trigger animation
      requestAnimationFrame(() => {
        newWrapper.classList.add('fade-in');
      });

      // ** End of skeletong wrapper logic ** 

      renderDevicesLayout();
      updateCounterFromShopify(doc);
    }

    // update facets
    const currentFacets = document.querySelector('.facets-summary');
    if (newFacets && currentFacets) {
      currentFacets.innerHTML = newFacets.innerHTML;
    }

    const urlPromotionParams = url.searchParams.getAll('filter.p.m.custom.device_promotion');
    const isCarrierPromotion = urlPromotionParams ? urlPromotionParams.some(value => value.startsWith('promotion_')) : false;

    // update checkboxes state
    syncFacetsFromShopify(doc, isCarrierPromotion);

    // update pagination
    const currentPagination = document.querySelector('.collection__pagination');

    if (currentPagination) {
      if (newPagination) {
        currentPagination.innerHTML = newPagination.innerHTML;
        currentPagination.style.display = "";
      } else {
        currentPagination.innerHTML = "";
        currentPagination.style.display = "none";
      }
    }

    // Re-initiliaze events when paginating
    initFilterEvents();

    // update URL (CRITICAL)
    url.searchParams.delete('section_id');
    window.history.replaceState({}, '', url.toString());

  } catch (err) {
    console.error('Facet AJAX error:', err);
  }
}

/* -----------------------------
Back / Forward navigation
----------------------------- */
window.addEventListener('popstate', () => {
  if (!filterForm) return;

  // Re-fetch using current URL
  applyFiltersAJAX(filterForm);
});

/* -----------------------------
Clear filters (AJAX)
----------------------------- */
document.addEventListener('click', function(e) {
  if (!e.target.classList.contains('filters-clear')) return;

  e.preventDefault();

  const form = document.querySelector('.facets__form');

  form.querySelectorAll('input[type="checkbox"]').forEach(input => {
    input.checked = false;
    input.removeAttribute('disabled');
  });

  applyFiltersAJAX(form);

  // Hide Apple banner
  document.querySelector('#apple-banner')?.classList.add('hidden');
});

/* =========================================================
Province filtering
========================================================= */
function renderDevicesLayout() {
  const paramsUrl = new URLSearchParams(window.location.search);
  let provinceSelected = paramsUrl.get('prov');

  if (!provinceSelected) {
    provinceSelected = localStorage.getItem('ProvinceValue');
  }

  if (!provinceSelected) return;

  provinceSelected = provinceSelected.toLowerCase();

  document.querySelectorAll('.product-card').forEach(el => {
    if (el.classList.contains('skeleton-card')) return;
    
    const tags = (el.dataset.productTags || '').toLowerCase();
  });
}

/* =========================================================
Init
========================================================= */
document.addEventListener('DOMContentLoaded', () => {
  const url = new URL(window.location.href);
  const provinceTag = `province_${provinceValue?.toUpperCase()}`;

  if (!url.searchParams.getAll('filter.p.m.custom.device_province').includes(provinceTag)) {
    addProvinceFilter();
  } else {
    initFilterEvents(url); // only if no reload happens
  }
});

function addProvinceFilter() {
  const url = new URL(window.location.href);

  if (!provinceValue) return;

  // avoid infinite reload loop
  if (url.searchParams.get('filter.p.m.custom.device_province') === provinceTag) return;

  const existing = url.searchParams.getAll('filter.p.m.custom.device_province');

  if (!existing.includes(provinceTag)) {
    url.searchParams.append('filter.p.m.custom.device_province', provinceTag);
  }

  applyFiltersFromURL(url.toString());
}

let filterTimeout = null;

async function initFilterEvents(url = null) {

  const form = document.querySelector('.facets__form');
  if (!form) return;

  if (form.dataset.bound === "true") return;
  form.dataset.bound = "true";

  // prevent native submit
  form.addEventListener('submit', (e) => {
    e.preventDefault();
  });

  // preload on change
  form.addEventListener('change', (e) => {

    if (!e.target.matches('input[type="checkbox"]')) return;

    clearTimeout(filterTimeout);

    filterTimeout = setTimeout(() => {
      preloadFilters(form);
    }, 150);
  });

  // bind APPLY button (important)
  const applyBtn = form.closest('form')?.querySelector('.filters-apply') || document.querySelector('.filters-apply');

  if (applyBtn) {
    applyBtn.addEventListener('click', (e) => {
      e.preventDefault();
      
      applyFiltersAJAX(form);
      updateAppleBanner();

    });
  }

  compareItemLimit();
}


/* =========================================================
 Facets
========================================================= */

function ensureFacetsVisible() {
  const facets = document.querySelector('.facets__form');
  if (!facets) return;

  facets.style.display = 'block';
}

function syncFacetsFromShopify(doc, isCarrierPromotion = false) {
  const newInputs = doc.querySelectorAll('.facets__form input[type="checkbox"]');
  
  const newState = new Map();
  
  newInputs.forEach(input => {
    if ( isCarrierPromotion && input.value == "deals_Promotion") {
      input.checked = true;
    }
    newState.set(input.value, input.checked);
  });
  
  document.querySelectorAll('.facets__form input[type="checkbox"]').forEach(input => {
    if (newState.has(input.value)) {
      input.checked = newState.get(input.value);
    }
  });
}


/* =========================================================
Mobiles and tablets only
========================================================= */
if (window.innerWidth <= 999) {
  initProvinceInjection();
}

function initProvinceInjection(){
  const FORM_SELECTOR = '#facet-form';

  if (window.__provinceListenerAttached) return;
  window.__provinceListenerAttached = true;

  function injectHiddenInput(form, name, value) {
    let input = form.querySelector(`input[name="${name}"]`);

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }

    input.value = value;
  }

  function ensureProvinceParams(form) {
    const provinceValue = getProvinceValue();
    if (!provinceValue) return;

    const existingProv = form.querySelector('input[name="prov"]')?.value;
    const existingTag = form.querySelector('input[name="filter.p.m.custom.device_province"]')?.value;

    // If already correct → do nothing
    if (existingProv === provinceValue && existingTag === provinceTag) {
        return;
    }

    injectHiddenInput(form, 'prov', provinceValue);
    injectHiddenInput(form, 'filter.p.m.custom.device_province', provinceTag);
  }

  // ===============================
  // Also cover submit fallback
  // ===============================
  document.addEventListener('submit', function (e) {
    const form = e.target;

    if (!form.matches(FORM_SELECTOR)) return;
    // buildFilterURL(form);
    ensureProvinceParams(form);

  }, true); // capture here too
}

/* =========================================================
Comparable products logic
========================================================= */
function compareItemLimit() {
  $(".comparable-custom-action").css({ "pointer-events": "visible" });
  $(".collection-device-plp .product-card__figure").css({ "pointer-events": "visible" });
  $(".product-card__title_filter").css({ "pointer-events": "visible" });

  if (localStorage.getItem("DeviceCompareCount") >= 3) {
    setTimeout(function () {
      $('.collection-device-plp .collection__results .comparable-custom-action .add-to-comparable').each(function () {
        if ($(this).hasClass("in-comparison")) {
          $(this).parent().addClass("comp_selected");
          $(this).parent().css({ "pointer-events": "visible", "opacity": "1" });
        } else {
          $(this).parent().removeClass("comp_selected");
          $(this).parent().css({ "pointer-events": "none", "opacity": "0.3" });
        }
      });
    }, 1000);
  }
  $('.collection-device-plp .collection__results .comparable-custom-action').on('click', function () {
    var comp_local_count = localStorage.getItem("DeviceCompareCount");
    if ($(this).hasClass('comp_selected')) {
      $(this).removeClass('comp_selected');
      $(this).find('input').attr("aria-checked", false)
      comp_local_count--;
    } else {
      $(this).addClass('comp_selected');
      $(this).find('input').attr("aria-checked", true)
      comp_local_count++;
    }

    localStorage.setItem("DeviceCompareCount", comp_local_count);
    if (localStorage.getItem("DeviceCompareCount") >= 3) {
      $('.collection-device-plp .collection__results .comparable-custom-action').each(function () {
        if ($(this).hasClass("comp_selected")) {
          $(this).css({ "pointer-events": "visible", "opacity": "1" });
        } else {
          $(this).css({ "pointer-events": "none", "opacity": "0.3" });
        }
      });
    } else {
      $('.collection-device-plp .collection__results .comparable-custom-action').each(function () {
        $(this).css({ "pointer-events": "visible", "opacity": "1" });
      });
    }
    if (localStorage.getItem("DeviceCompareCount") <= 1) {
      $(".compare-products-actions .open-compare-link").css({ "pointer-events": "none", "opacity": "0.3" }).attr("aria-disabled", "true");
    } else {
      $(".compare-products-actions .open-compare-link").css({ "pointer-events": "visible", "opacity": "1" });
    }
    if (localStorage.getItem("DeviceCompareCount") == 0) {
      setTimeout(function () {
        $('.close-bar')[0].click();
      }, 100);
    }
  });
  if (localStorage.getItem("PlanCompareCount") > 0) {
    $(".collection-device-plp .comparable-custom-action").css({ "pointer-events": "none", "opacity": "0.3" });
  }

  $('.compare-products-actions .close-bar').on("click", function(){
    localStorage.setItem("DeviceCompareCount", 0);
  })
}

// WCAG - Compare checkbox
$('body').on('keydown', 'input.add-to-comparable', function (event) {
  if (event.key === ' ' || event.key === 'Enter' || event.key === 'Space') {
    event.preventDefault();

    const compareTriggerButton = $(this);
    const modalCompare = $('.compare-bar')
    const firstElementCompare = modalCompare.find('.close-bar')
    const lastElementCompare = modalCompare.find('.open-compare-link')
    const compareCloseBar = firstElementCompare[0];
    const compareDevices = lastElementCompare[0];

    this.click();
    compareDevices.focus();

    const observer = new MutationObserver(function (mutationList, observer) {
        const removeDevices = $(".compare-products-list .compare-products-item-remove-btn");
        const firstDevice = removeDevices[0];

        // Store the event listener function for keydown
        const trapFocusHandlerCompare = (e) => {
            if (e.key === 'Tab') {
                if (e.shiftKey) {  // If Shift+Tab is pressed, focus on last element
                    if (document.activeElement === firstDevice) {
                        e.preventDefault();
                        compareCloseBar.focus();
                    } else if (document.activeElement === compareDevices) {
                        e.preventDefault();
                        compareCloseBar.focus();
                    } else if (document.activeElement === compareCloseBar) {
                        e.preventDefault();
                        compareTriggerButton.focus();
                    }
                } else {  // If Tab key is pressed, focus on first element if at the end
                    if (document.activeElement === compareDevices) {
                        if (removeDevices.length > 0) {
                            e.preventDefault();
                            firstDevice.focus();
                        } else {
                            e.preventDefault();
                            compareCloseBar.focus();
                        }
                    } else if (document.activeElement === firstDevice) {
                        e.preventDefault();
                        compareCloseBar.focus();
                    } else if (document.activeElement === compareCloseBar) {
                        e.preventDefault();
                        compareTriggerButton.focus();
                    }
                }
            }
        };

        // Add the keydown event listener to trap focus
        modalCompare.on('keydown', trapFocusHandlerCompare);

        const closeHandlerCompare = () => {
            modalCompare.off('keydown', trapFocusHandlerCompare);
            firstElementCompare.off('click', closeHandlerCompare);
            compareTriggerButton.focus();
        };

        // Add the click event listener for closing the modal
        firstElementCompare.on('click', closeHandlerCompare);

        observer.disconnect();
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    })

  }
});


function updateAppleBanner() {
    const banner = document.querySelector('#apple-banner');
    if (!banner) return;

    const checkedDevices = document.querySelectorAll(
      '#filter-device-type input[name="filter.p.m.custom.devices"]:checked'
    );

    const onlyApple = checkedDevices.length === 1 && checkedDevices[0].value === 'Apple';
      
    banner.classList.toggle('hidden', !onlyApple);
}

compareItemLimit();
